<template>
  <div>
    <div class="steps-container separate--after">
      <ol>
        <li v-for="(step, index) in steps" :key="index" :class="stepStyle(index)" @click="stepChange(index)">
          {{ step }}
        </li>
      </ol>
    </div>

    <slot />
  </div>
</template>

<script>
// @vuese
// Zakładki kroków formularzy
// @group MaterialStepper
export default {
  props: {
    // Aktualny krok
    activeStep: { type: Number },
    // Lista kroków
    steps: { type: Array }
  },
  methods: {
    // @vuese
    // Ustawia odpowiedni styl zakładki
    // @param index - indeks zakładki
    stepStyle(index) {
      if (index < this.activeStep) {
        return 'step--past';
      }
      if (index === this.activeStep) {
        return 'step--active';
      }
    },
    // @vuese
    // Zmienia krok zakładki
    // @param index - indeks docelowej zakładki
    stepChange(index) {
      if (index >= this.activeStep) {
        return;
      }
      this.$emit('change', index);
    }
  }
};
</script>
